import Vue from "vue";
import MapProject from "./MapProject.vue";
import vuelidate from "vuelidate";
import * as VueGoogleMaps from "vue2-google-maps";
import { prepareConfigs, prepareRequestApi } from "@/utils/request";
import axios from "axios";
//import { centralCoast } from "@/utils/helpers";

// async function geocodeZip(zip) {
//   const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${zip}&key=AIzaSyCOWIy9g6joDFsU8QkSJSjxtqGL5Qhzbxw`);
//   const data = await response.json();
//   if (data.status === "OK") {
//     const loc = data.results[0].geometry.location;
//     return { zipcode: zip, position: { lat: loc.lat, lng: loc.lng } };
//   } else {
//     console.warn("Не удалось найти ZIP", zip);
//     return null;
//   }
// }

// async function processZipCodes(zipCodes, batchSize = 50, delay = 1500) {
//   const results = [];
//
//   for (let i = 0; i < zipCodes.length; i += batchSize) {
//     const batch = zipCodes.slice(i, i + batchSize);
//     const promises = batch.map(zip => geocodeZip(zip));
//     const batchResults = await Promise.all(promises);
//
//     results.push(...batchResults.filter(Boolean));
//     console.log(`Processed batch ${i / batchSize + 1}: ${batchResults.length} ZIPs`);
//
//     if (i + batchSize < zipCodes.length) {
//       console.log("Waiting...");
//       await new Promise(r => setTimeout(r, delay));
//     }
//   }
//
//   console.log("✅ All done:", results);
//   return results;
// }

Vue.use(vuelidate);

(async function() {
  if (!document.querySelector("#zipcode-map-project")) {
    return;
  }
  // const zipcodes = [];
  // centralCoast.forEach((item) => {
  //   item['zipCodes'].forEach((zip) => {
  //     zipcodes.push(zip);
  //   });
  // });
  // console.log('zipcodes', zipcodes);
  //
  // (async () => {
  //   const zipLocations = await processZipCodes(zipcodes);
  //   console.log(JSON.stringify(zipLocations, null, 2));
  // })();


  const request = prepareRequestApi();
  const keyData = await axios(request);

  if (keyData.status !== 200) {
    alert("Config Google API Key Error");
  }
  const key: string = keyData.data;

  Vue.use(VueGoogleMaps, {
    load: {
      language: "En",
      key: key,
      libraries: "places" // This is required if you use the Autocomplete plugin
    },
    autobindAllEvents: false
  });
  Vue.config.productionTip = false;

  const requestConfig = prepareConfigs();
  const resultData = await axios(requestConfig);
  if (resultData.status == 200) {
    Vue.prototype.$globalConfig = resultData.data;
  }

  if (process.env.NODE_ENV === "development") {
    Vue.config.devtools = true;
    (window as any).Vue = Vue;

    console.log("Vue:", Vue.version);
    console.log("NODE_ENV:", process.env.NODE_ENV);
    console.log("Vue config devtools:", Vue.config.devtools);
  }

  new Vue({
    render: h => h(MapProject)
  }).$mount("#zipcode-map-project");
})();
